export default "__VITE_ASSET__CuX3GhK$__"